import React from "react";

function FoodProductCodeField({foodProductCodeArr, by}){
	let passedValues = [];
	if(by === "fda"){
		passedValues = foodProductCodeArr.fdaIndustryCodeArr;
	} else if(by === "hts"){
		passedValues = foodProductCodeArr.htsCodeArr;
	} else if(by === "usda"){
		passedValues = foodProductCodeArr.usdaCodeArr;
	} 
	return(
		passedValues.map( (passedValue) =>(
			(by === "fda" )?
			<tr>
				<td>{passedValue["fda_product_code"]}</td>  
				<td>{passedValue["description"]}</td>
			</tr>
			:
			(by === "hts")?
			<tr>
				<td>{passedValue["hts_code"]}</td>
				<td>{passedValue["long_description"]}</td>
			</tr>
			: 
			(by === "usda") ?
			<tr>
				<td>{passedValue["usda_ndb_code"]}</td> 
				<td>{passedValue["description"]}</td>
			</tr>
			: ""
		))
	)
}

export default FoodProductCodeField;